import { faDoorClosed, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { infProdutoPerigosoInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { useRef, useState } from "react";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../../components/Components";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import {
    addProdutoPerigosoCTe,
    removeProdutoPerigosoCTe,
    removeProdutoPerigosoCTeTodos
} from "../../../../features/manifestoSlice";

interface formProps {
    id: number | string;
    show: boolean;
    handleClose: () => void;
}

const initialForm: infProdutoPerigosoInterface = {
    id: 0,
    nONU: '',
    xNomeAE: '',
    xClaRisco: '',
    grEmb: '',
    qTotProd: '',
    qVolTipo: ''
}

const CTesProdutoPerigoso: React.FC<formProps> = ({ show, handleClose, id }) => {
    const [form, setForm] = useState<infProdutoPerigosoInterface>(initialForm);
    const nONURef = useRef<HTMLInputElement>(null)
    const xNomeAERef = useRef<HTMLInputElement>(null)
    const xClaRiscoRef = useRef<HTMLInputElement>(null)
    const grEmbRef = useRef<HTMLInputElement>(null)
    const qTotProdRef = useRef<HTMLInputElement>(null)
    const qVolTipoRef = useRef<HTMLInputElement>(null)
    const { confirm, ConfirmModal } = useQuestion();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto)
        .infMunDescarga.flatMap(item => item.infCTe)
        .filter(item => item?.id?.toString() === id.toString())
        .flatMap(item => item?.peri)
    const { alertModal, ModalMessageEl } = useModalMessage();
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');

    const validaPreenchimento = () => {
        if (form.nONU.trim() === "") {
            goToFocus(nONURef);
            alertModal('Informe o número ONU/UN.')
            return false;
        }
        if (!/[0-9]{4}|ND/.test(form.nONU)) {
            goToFocus(nONURef);
            alertModal('Número ONU/UN deve conter 4 números ou ND.')
            return false;
        }
        if (form.xNomeAE.trim() === "") {
            goToFocus(xNomeAERef);
            alertModal('Informe o Nome apropriado para embarque do produto.');
            return false;
        }

        if (form.xClaRisco.trim() === "") {
            goToFocus(xClaRiscoRef);
            alertModal('Informe a Classe ou subclasse/divisão, e risco subsidiário/risco secundário.');
            return false;
        }
        if (form.grEmb.trim() === "") {
            goToFocus(grEmbRef);
            alertModal('Informe o Grupo de Embalagem.');
            return false;
        }

        if (form.qTotProd.trim() === "") {
            goToFocus(qTotProdRef);
            alertModal('Informe a quantidade total por produto.')
            return false;
        }

        if (form.qVolTipo.trim() === "") {
            goToFocus(qVolTipoRef);
            alertModal('Informe a Quantidade e Tipo de volumes.');
            return false;
        }

        return true;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAdd = () => {

        if (validaPreenchimento()) {
            dispatch(addProdutoPerigosoCTe({
                cteId: id,
                peri: {
                    ...form,
                    id: getUuidV4()
                }
            }))
            setForm(initialForm);
            goToFocus(nONURef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {

        if (lista?.length > 0) {
            setSelecionado(value.id);
            const confirmed = await confirm({
                message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
                title: "Confirmação"
            });
            
            if (confirmed) {
                dispatch(removeProdutoPerigosoCTe({
                    id: value.id,
                    cteId: id
                }))
            }
            setSelecionado('');
        }
    }

    const handleRemoverTudo = async () => {
        if (lista?.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            
            if (confirmed) {
                dispatch(removeProdutoPerigosoCTeTodos({
                    cteId: id
                }))
            }
        }
    }

    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' size="lg" fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton className="py-2">
                <Modal.Title>Produto Perigoso ONU (Opcional)</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row className="mb-3 g-2">
                    <Col md={3}>
                        <Form.Group controlId="cte-nONU">
                            <Form.Label>* Número ONU/UN</Form.Label>
                            <Form.Control name="nONU" maxLength={4} ref={nONURef}

                                onChange={handleChange} value={form.nONU} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="cte-xNomeAE">
                            <Form.Label>* Nome Ap. Emb. Produto</Form.Label>
                            <Form.Control maxLength={150} name="xNomeAE" ref={xNomeAERef}

                                onChange={handleChange} value={form.xNomeAE} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="mb-3 g-2">
                    <Col md>
                        <Form.Group controlId="cte-xClaRisco">
                            <Form.Label>* Classe de Risco</Form.Label>
                            <Form.Control maxLength={40} name="xClaRisco" ref={xClaRiscoRef}

                                onChange={handleChange} value={form.xClaRisco} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="cte-grEmb">
                            <Form.Label>* Grupo de Embalagem</Form.Label>
                            <Form.Control maxLength={6} name="grEmb" ref={grEmbRef}

                                onChange={handleChange} value={form.grEmb} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="mb-3 g-2">
                    <Col md>
                        <Form.Group controlId="cte-qTotProd">
                            <Form.Label>* Qtd. Total por Produto</Form.Label>
                            <Form.Control maxLength={20} name="qTotProd" ref={qTotProdRef}

                                onChange={handleChange} value={form.qTotProd} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="cte-qVolTipo">
                            <Form.Label>* Qtd. e Tipo de Volumes</Form.Label>
                            <Form.Control maxLength={60} name="qVolTipo" ref={qVolTipoRef}

                                onChange={handleChange} value={form.qVolTipo} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button variant="primary" onClick={handleAdd} >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>

                </Row>

                <JTable>
                    <JTHead >
                        <tr>
                            <th className="text-center">
                                <ButtonTrash onClick={() => handleRemoverTudo()} />
                            </th>
                            <th>Num ONU/UN</th>
                            <th>Classe Risco</th>
                            <th>Qtd. Total Produto</th>
                        </tr>
                    </JTHead>
                    <JTBody>

                        {lista?.map((item: infProdutoPerigosoInterface) => {
                            return (
                                <tr key={item.id}
                                    className={(item.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                    <td className="text-center">
                                        <ButtonRemover onClick={() => handleRemover({ id: item.id, title: item.nONU })} />
                                    </td>
                                    <td>{item.nONU}</td>
                                    <td>{item.xClaRisco}</td>
                                    <td>{item.qTotProd}</td>
                                </tr>
                            )
                        })}

                    </JTBody>
                </JTable>
                {ConfirmModal}
                {ModalMessageEl}
            </Modal.Body>

            <Modal.Footer className="py-2">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}
export default CTesProdutoPerigoso;